"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewReturnContext = exports.QueryKey = void 0;
var react_1 = __importStar(require("react"));
var react_query_1 = require("react-query");
var devtools_1 = require("react-query/devtools");
var react_router_dom_1 = require("react-router-dom");
var api_1 = require("./api");
var confirmation_1 = __importDefault(require("./pages/confirmation"));
var list_returns_1 = __importDefault(require("./pages/list-returns"));
var reasons_1 = __importDefault(require("./pages/reasons"));
var returnMethod_1 = __importDefault(require("./pages/returnMethod"));
var review_1 = __importDefault(require("./pages/review"));
var selectItems_1 = __importDefault(require("./pages/selectItems"));
exports.QueryKey = {
    ELIGIBLE_RETURN_ORDERS: "EligibleReturnOrders",
    GET_RETURN_DECISION: "GetReturnDecision",
    GET_RETURNS: "GetReturns",
    MUTATION_CREATE_SUPPORT_TICKET: "MutationCreateSupportTicket",
    MUTATION_CREATE_RETURN: 'MutationCeateReturn',
    MUTATION_EMAIL_RETURN_LABEL: 'MutationEmailReturnLabel',
};
var queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        },
    },
});
exports.NewReturnContext = (0, react_1.createContext)(undefined);
exports.default = (function (_a) {
    var customer = _a.customer;
    // const newReturns = () => <NewReturn basePath='/returns/new' />
    var basePath = '/returns/new';
    var _b = __read((0, react_1.useState)([]), 2), selectedItems = _b[0], setSelectedItems = _b[1];
    var _c = __read((0, react_1.useState)(), 2), returns = _c[0], setReturns = _c[1];
    var _d = __read((0, react_1.useState)(), 2), createReturnInput = _d[0], setCreateReturnInput = _d[1];
    var _e = __read((0, react_1.useState)(), 2), customerSelectedReturnOffer = _e[0], setCustomerSelectedReturnOffer = _e[1];
    var _f = __read((0, react_1.useState)(0), 2), csNumDays = _f[0], setCsNumDays = _f[1];
    var selectItems = function () { return react_1.default.createElement(selectItems_1.default, { basePath: basePath }); };
    var reasonsPage = function () { return react_1.default.createElement(reasons_1.default, { basePath: basePath }); };
    var returnMethodPage = function () { return react_1.default.createElement(returnMethod_1.default, { basePath: basePath }); };
    var reviewPage = function () { return react_1.default.createElement(review_1.default, { basePath: basePath }); };
    var confirmationPage = function () { return react_1.default.createElement(confirmation_1.default, { basePath: basePath }); };
    var graphQLClient = (0, api_1.getSublessAPIClient)();
    (0, react_1.useEffect)(function () {
        $('#launcher').hide(); // zendesk
        $('#smile-ui-container').hide();
    });
    var returnComplete = function () {
        setSelectedItems([]);
        setReturns(undefined);
        setCreateReturnInput(undefined);
        setCustomerSelectedReturnOffer(undefined);
    };
    return (react_1.default.createElement(react_query_1.QueryClientProvider, { client: queryClient },
        react_1.default.createElement("div", { className: 'account-app-v3' },
            react_1.default.createElement("div", { className: 'padding-bottom-3' },
                react_1.default.createElement(exports.NewReturnContext.Provider, { value: {
                        selectedItems: selectedItems,
                        setSelectedItems: setSelectedItems,
                        returns: returns,
                        setReturns: setReturns,
                        createReturnInput: createReturnInput,
                        setCreateReturnInput: setCreateReturnInput,
                        customerSelectedReturnOffer: customerSelectedReturnOffer,
                        setCustomerSelectedReturnOffer: setCustomerSelectedReturnOffer,
                        returnComplete: returnComplete,
                        graphqlClient: graphQLClient,
                        csNumDays: csNumDays,
                        setCsNumDays: setCsNumDays,
                    } }, customer && (react_1.default.createElement(react_router_dom_1.HashRouter, null,
                    react_1.default.createElement(react_router_dom_1.Switch, null,
                        react_1.default.createElement(react_router_dom_1.Route, { path: "".concat(basePath, "/selectItems"), component: selectItems }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "".concat(basePath, "/reasons"), component: reasonsPage }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "".concat(basePath, "/returnMethod"), component: returnMethodPage }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "".concat(basePath, "/review"), component: reviewPage }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "".concat(basePath, "/confirmation"), component: confirmationPage }),
                        react_1.default.createElement(react_router_dom_1.Route, { path: "/returns", component: list_returns_1.default }))))))),
        react_1.default.createElement(devtools_1.ReactQueryDevtools, { initialIsOpen: false })));
});
